import React, { useContext } from 'react';
import { isStatBankGDLink } from '@/utils';
import { SystemFeaturesContext } from '../ContextProviders';
import { StatBankItemType } from '@/api/statbank-data';
import ScissorIcon from '../../assets/scissors-light.svg';
import GDLogo from '@/assets/gd-logo.svg';
import classNames from 'classnames';

type StatBankItemProps = {
  data: StatBankItemType;
  isSelected?: boolean;
  className?: string;
  loading?: boolean;
  toggleItemSelection?: (item: StatBankItemType) => void;
  handleSaveToScrapbook?: () => void;
  onClick?: () => void;
};

const StatBankItem = ({
  data,
  isSelected,
  className,
  loading,
  toggleItemSelection,
  handleSaveToScrapbook,
  onClick,
}: StatBankItemProps) => {
  const { staffPdfLink, saveToScrapbook: saveToScrapbookFeature } = useContext(SystemFeaturesContext);

  return (
    <div
      className={classNames('group flex flex-col flex-wrap items-start py-3 sm:flex-row sm:items-center', className)}
    >
      {staffPdfLink && toggleItemSelection && (
        <div className="w-1/12 print:hidden">
          <input
            type="checkbox"
            checked={isSelected}
            onChange={() => toggleItemSelection(data)}
            className="mr-8 h-4 w-4 cursor-pointer accent-black"
          />
        </div>
      )}
      <div
        className={classNames(
          'flex flex-1 flex-col sm:flex-row sm:items-center',
          data.statLink && onClick ? 'cursor-pointer' : '',
          saveToScrapbookFeature ? 'md:w-10/12' : 'md:w-11/12',
        )}
        onClick={onClick}
      >
        <div className="number-wrapper mb-2 flex w-full items-center justify-between sm:mb-0 sm:w-1/4">
          <div className="number text-[24px] leading-[1.2] font-light md:text-[23px] md:leading-[38px] lg:text-[20px] xl:text-[30px]">
            {data.number}
          </div>
          {data.statLink && isStatBankGDLink(data.statLink) && (
            <div className="px-2 md:hidden">
              <GDLogo className="h-7 w-7 fill-[#252628]" />
            </div>
          )}
        </div>
        <div className="description flex w-full items-center justify-between text-[14px] leading-[18px] sm:w-3/4 sm:pl-3 sm:text-[16px] sm:leading-[22px]">
          {loading ? <div className="h-8 animate-pulse bg-gray-300"></div> : data.description}
          {data.statLink && isStatBankGDLink(data.statLink) && (
            <div className="hidden px-2 md:block">
              <GDLogo className="h-7 w-7 fill-[#252628]" />
            </div>
          )}
        </div>
      </div>

      {saveToScrapbookFeature && handleSaveToScrapbook && (
        <div
          className={`transition-opacity sm:opacity-0 sm:group-hover:opacity-100 ${isSelected ? 'opacity-100' : 'opacity-0'}`}
        >
          <button
            onClick={(e) => {
              e.stopPropagation();
              handleSaveToScrapbook();
            }}
            className="flex h-8 w-8 cursor-pointer items-center justify-center rounded-full hover:bg-gray-100"
            title="Save to Scrapbook"
          >
            <ScissorIcon className="h-6 w-6" />
          </button>
        </div>
      )}
    </div>
  );
};

export default StatBankItem;
